//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

//#endregion

//-----------------------------------------------------------------
export function Logo() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();
  const _styles = {
    logo: {
      height          : '100%',
      borderRadius    : '20px',
      marginRight     : theme.spacing(1),
      padding         : '3px 0px 3px 0',
    }
  }

  //#endregion

  //#region [DISPLAY]
  const logo = theme.palette.mode === 'dark' ? `${process.env.PUBLIC_URL}/Logo-dark.svg` : `${process.env.PUBLIC_URL}/Logo-light.svg`;

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box sx={_styles.logo} >
        <img alt='paradatec' src={logo} height='100%' />
      </Box>
    );
  }

  //#endregion

  return display();
}
